import { AxiosRequestConfig } from 'axios'

import apiClient from '@/lib/apiClient'

interface AxiosPostConfig extends AxiosRequestConfig {
  customErrorHandling?: boolean
}

/**
 * Sends a POST request to the specified URL with the given data and configuration.
 * @template TRequest The type of the request data.
 * @template TResponse The type of the response data.
 * @param {string} url The URL to send the request to.
 * @param {TRequest} data The data to send with the request.
 * @param {AxiosRequestConfig} [config] The configuration for the request.
 * @returns {Promise<TResponse>} A promise that resolves with the response data.
 * @throws {AxiosError} If the request fails.
 */
export async function post<TRequest, TResponse>(
  url: string,
  data: TRequest,
  config?: AxiosPostConfig,
): Promise<TResponse> {
  const response = await apiClient.post<TResponse>(url, data, config)

  return response.data
}
